import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-148">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/60 z-50" onClick={onClose} data-id="element-149" />
          <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-4 md:inset-x-auto md:inset-y-8 md:max-w-2xl md:mx-auto bg-white rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-150">
            <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-151">
              <h2 className="font-serif text-2xl font-bold text-brand-dark" data-id="element-152">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-153">
                <XIcon size={20} className="text-gray-500" data-id="element-154" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-6 text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-155">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}
export function PrivacyContent() {
  return <>
      <p data-id="element-156">
        <strong data-id="element-157">Última actualización:</strong> Marzo 2026
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-158">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-159">
        Recopilamos información personal que usted nos proporciona directamente
        al realizar una compra, incluyendo: nombre, dirección de correo
        electrónico e información de pago. No almacenamos datos de tarjetas de
        crédito; estos son procesados de forma segura por nuestro proveedor de
        pagos.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-160">
        2. Uso de la Información
      </h3>
      <p data-id="element-161">Utilizamos su información para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-162">
        <li data-id="element-163">Procesar y entregar su compra digital.</li>
        <li data-id="element-164">Enviar confirmaciones de pedido y actualizaciones del producto.</li>
        <li data-id="element-165">Responder a sus consultas de soporte.</li>
        <li data-id="element-166">Mejorar nuestros productos y servicios.</li>
      </ul>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-167">
        3. Protección de Datos
      </h3>
      <p data-id="element-168">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-169">4. Cookies</h3>
      <p data-id="element-170">
        Nuestro sitio puede utilizar cookies para mejorar su experiencia de
        navegación y analizar el tráfico del sitio. Puede configurar su
        navegador para rechazar cookies.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-171">5. Terceros</h3>
      <p data-id="element-172">
        No vendemos, intercambiamos ni transferimos su información personal a
        terceros, excepto a proveedores de servicios de confianza que nos ayudan
        a operar nuestro sitio web y procesar pagos.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-173">
        6. Sus Derechos
      </h3>
      <p data-id="element-174">
        Usted tiene derecho a acceder, corregir o eliminar su información
        personal. Para ejercer estos derechos, contáctenos a través de nuestro
        correo electrónico de soporte.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-175">7. Contacto</h3>
      <p data-id="element-176">
        Si tiene preguntas sobre esta política de privacidad, puede contactarnos
        a través de nuestro correo electrónico de soporte.
      </p>
    </>;
}
export function TermsContent() {
  return <>
      <p data-id="element-177">
        <strong data-id="element-178">Última actualización:</strong> Marzo 2026
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-179">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-180">
        Al acceder y utilizar este sitio web y al realizar una compra del
        producto digital "Código Spanglish", usted acepta estar sujeto a estos
        términos y condiciones de servicio.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-181">
        2. Producto Digital
      </h3>
      <p data-id="element-182">
        "Código Spanglish" es un producto digital (PDF) que se entrega
        electrónicamente. Al completar su compra, recibirá acceso inmediato para
        descargar el material.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-183">
        3. Licencia de Uso
      </h3>
      <p data-id="element-184">
        Al comprar el producto, usted recibe una licencia personal e
        intransferible para usar el contenido. Queda prohibida la reproducción,
        distribución o reventa del material sin autorización expresa.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-185">
        4. Política de Reembolso
      </h3>
      <p data-id="element-186">
        Debido a la naturaleza digital del producto y su entrega inmediata,
        todas las ventas son finales. Si experimenta problemas técnicos con la
        descarga, nuestro equipo de soporte le asistirá.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-187">
        5. Descargo de Responsabilidad
      </h3>
      <p data-id="element-188">
        El contenido de "Código Spanglish" es de carácter informativo y
        educativo. No sustituye el consejo profesional de un psicólogo,
        terapeuta familiar o profesional de salud mental. Los resultados pueden
        variar según cada familia.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-189">
        6. Propiedad Intelectual
      </h3>
      <p data-id="element-190">
        Todo el contenido, incluyendo textos, gráficos, logotipos y diseño, es
        propiedad de Código Spanglish y está protegido por las leyes de
        propiedad intelectual.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-191">
        7. Modificaciones
      </h3>
      <p data-id="element-192">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio web.
      </p>

      <h3 className="font-bold text-base text-brand-dark mt-6" data-id="element-193">8. Contacto</h3>
      <p data-id="element-194">
        Para cualquier consulta relacionada con estos términos, puede
        contactarnos a través de nuestro correo electrónico de soporte.
      </p>
    </>;
}